import gql from 'graphql-tag';

export const CREATIVE_APPROVAL_MUTATION = gql`
  mutation CreativeApproval($creativeIds: [ID!]!, $approvalAction: CreativeApprovalEnum!) {
    creativeApproval(creativeIds: $creativeIds, approvalAction: $approvalAction) {
      creatives {
        id
      }
      errors
    }
  }
`;
